"use client";

import * as React from "react";
import { Text, SectionCard, CardTitle, CardDescription, Section, Separator } from "@/src/components";
import { InstallCommand } from "@/components/docs/install-command";

export default function DocsComponentsSeparator() {
  return (
    <>
      <Section>
        <div className="space-y-4">
          <Text as="h1" className="text-h2 font-bold">
            Separator
          </Text>
          <Text className="text-lg text-muted-foreground max-w-2xl">
            Visually separates content with a horizontal or vertical line.
          </Text>
        </div>
      </Section>

      {/* Installation */}
      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Installation</CardTitle>
              <CardDescription>Add this component to your project</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <InstallCommand command="npx shadcn@latest add @bluecopa-ui/separator" />
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Horizontal</CardTitle>
              <CardDescription>Default horizontal separator</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <div className="space-y-4">
            <div>
              <Text className="font-medium">Section 1</Text>
              <Text className="text-sm text-muted-foreground">Content above the separator.</Text>
            </div>
            <Separator />
            <div>
              <Text className="font-medium">Section 2</Text>
              <Text className="text-sm text-muted-foreground">Content below the separator.</Text>
            </div>
          </div>
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Vertical</CardTitle>
              <CardDescription>Vertical separator for inline content</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <div className="flex h-5 items-center space-x-4 text-sm">
            <div>Home</div>
            <Separator orientation="vertical" />
            <div>Products</div>
            <Separator orientation="vertical" />
            <div>About</div>
          </div>
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={<CardTitle>Props</CardTitle>}
          contentClassName="p-6"
        >
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="text-left py-2 font-semibold">Prop</th>
                <th className="text-left py-2 font-semibold">Type</th>
                <th className="text-left py-2 font-semibold">Default</th>
                <th className="text-left py-2 font-semibold">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">orientation</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">"horizontal" | "vertical"</td>
                <td className="py-2 font-mono text-xs">"horizontal"</td>
                <td className="py-2 text-muted-foreground">Direction of the separator</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">decorative</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">boolean</td>
                <td className="py-2 font-mono text-xs">true</td>
                <td className="py-2 text-muted-foreground">Whether purely decorative</td>
              </tr>
            </tbody>
          </table>
        </SectionCard>
      </Section>
    </>
  );
}
